import Portal from 'components/common/utilities/portal';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class PortalModalWrapper extends React.PureComponent {
  render() {
    return (
      <Portal node={document && document.getElementById('modalPortal')}>
        <div className={this.props.className}>
          <ReactCSSTransitionGroup
            transitionAppear
            transitionName="Modal-backdrop"
            transitionAppearTimeout={1000}
            transitionEnterTimeout={1000}
            transitionLeaveTimeout={1}
          >
            <div className="Modal-backdrop" />
          </ReactCSSTransitionGroup>
          {this.props.children}
        </div>
      </Portal>
    );
  }
}

PortalModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/portal_modal_wrapper.jsx